import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Segments)',
  collection: {
    endpoint: '/api/admin/truevail/admin/deliverability/segments',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Text)', key: 'text', primary: true },
      { label: 't(Queued)', key: 'queued_count', collapsing: true, align: 'right' }
    ],
    defaultSort: { key: 'text', order: 'asc' },
    empty: {
      svg: 'list',
      title: 't(No Segments)',
      text: 't(There are no segments)'
    },
    entity: 'segment',
    onClick: (record) => context.router.push(`/admin/truevail/admin/segments/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)